<template>
  <VDialog
    v-model="_dialog"
    width="600px"
  >
    <VCard>
      <VCardTitle>
        <span class="headline">{{ cardTitle }}</span>
      </VCardTitle>
      <VCardText>
        {{ cardText }}
      </VCardText>
      <VCardActions>
        <v-spacer />
        <VBtn
          color="primary darken-1"
          flat="flat"
          @click="_dialog = false"
        >
          OK
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: 'OverflowedTextDialogCard',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    cardText: {
      type: String,
      default: ''
    },
    cardTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  }
}
</script>

<style scoped>

</style>
